import { FC } from "react";
import { cn } from "@/ui/lib";
import { BASE_INPUT_CLASSES, INPUT_ERROR_CLASSES } from "../forms.config";
import {
  INPUT_DEFAULTS,
  INPUT_TYPE_ICON_MAP,
  TInputFieldProps,
  WITH_ICON_CLASS,
} from "./Input.config";
import { InputIcon } from "./InputIcon";

export const InputField: FC<TInputFieldProps> = ({
  type = INPUT_DEFAULTS.type,
  value,
  disabled,
  error,
  className,
  ...props
}) => (
  <div className="relative w-full">
    <InputIcon type={type} />
    <input
      {...props}
      aria-invalid={!!error}
      type={type}
      value={value}
      disabled={disabled}
      className={cn(
        BASE_INPUT_CLASSES,
        "px-3 py-2 overflow-hidden overflow-ellipsis leading-none",
        INPUT_TYPE_ICON_MAP[type] ? WITH_ICON_CLASS : null,
        error && INPUT_ERROR_CLASSES,
        className,
      )}
    />
  </div>
);
